<template>
  <div class="wrapper">
    <div class="page-header">
      <div class="page-ribbon">
        <div class="path">
          <img src="@/assets/admin-icon/home-active.svg" />
          <pathViewer></pathViewer>
        </div>
        <div class="ribbon-options">
          <RoleManagement
            @onTeamSelected="TeamSelected"
            @onDeapartmentSelected="DeapartmentSelected"
          ></RoleManagement>
        </div>
      </div>
    </div>

    <div class="page-body" @scroll="yearScoll">
      <div class="main-content">
        <!-- Heatmap for members -->
        <div
          class="table-content"
          v-if="
            show_hit_map &&
            heatmap_data.data.length > 0 &&
            heatmap_view_type == 'member'
          "
          @click="mouse_position"
        >
          <div class="table-container" ref="table-content">
            <div class="table-row">
              <div class="consultant-item">
                <button class="btn-time-prev" @click="heatmapPrev()">
                  <img src="@/assets/admin-icon/chevron-left.svg" />
                </button>
              </div>
              <div
                v-for="(item, index) in heatmap_data.labels"
                :key="index"
                class="table-th-item"
                :class="{
                  has_year: (item.month == 'Jan' && index != 0) || index == 0,
                }"
              >
                <div class="year-label" v-if="index == 0">
                  {{ item.year | validate }}
                </div>
                <div
                  class="year-label"
                  v-if="item.month == 'Jan' && index != 0"
                >
                  {{ item.year | validate }}
                </div>
                <span
                  :class="{
                    year_number:
                      (item.month == 'Jan' && index != 0) || index == 0,
                  }"
                  >{{ item.month | validate }}</span
                >
              </div>

              <div class="comments-th" :class="{ expanded: comment_expand }">
                <button class="btn-next-time" @click="heatmapNext()">
                  <img src="@/assets/admin-icon/chevron-right.svg" />
                </button>
                <h3 @click="comment_expand = !comment_expand">Comments</h3>
                <button
                  class="btn-resize"
                  @click="comment_expand = !comment_expand"
                >
                  <span v-if="comment_expand">Minimize</span>
                  <span v-else>Expand</span>
                </button>
              </div>
            </div>
            <div
              class="table-td-row"
              v-for="(item, index) in heatmap_data.data"
              :key="index"
            >
              <div class="table-td-item-header">
                <div class="consultant">
                  <button
                    class="btn-toggle-team"
                    @click="expandHeatmapItem(item.team)"
                  >
                    <img
                      v-if="!item.team.item_expanded"
                      src="@/assets/admin-icon/gray-caret-down.svg"
                    />
                    <img v-else src="@/assets/admin-icon/gray-caret-up.svg" />
                  </button>
                  <div class="user-info">
                    <label>{{ item.team.profile.name | validate }} </label>
                  </div>
                </div>

                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_1
                      )
                    "
                    :style="{ 'background-color': item.team.cell_1.color }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_2
                      )
                    "
                    :style="{ 'background-color': item.team.cell_2.color }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_3
                      )
                    "
                    :style="{ 'background-color': item.team.cell_3.color }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_4
                      )
                    "
                    :style="{ 'background-color': item.team.cell_4.color }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_5
                      )
                    "
                    :style="{ 'background-color': item.team.cell_5.color }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_6
                      )
                    "
                    :style="{ 'background-color': item.team.cell_6.color }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_7
                      )
                    "
                    :style="{ 'background-color': item.team.cell_7.color }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_8
                      )
                    "
                    :style="{ 'background-color': item.team.cell_8.color }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_9
                      )
                    "
                    :style="{ 'background-color': item.team.cell_9.color }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_10
                      )
                    "
                    :style="{ 'background-color': item.team.cell_10.color }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_11
                      )
                    "
                    :style="{ 'background-color': item.team.cell_11.color }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.team,
                        'team',
                        item.team,
                        item.team.cell_12
                      )
                    "
                    :style="{ 'background-color': item.team.cell_12.color }"
                  ></div>
                </div>

                <div
                  class="heatmap-comment"
                  :class="{
                    expanded: comment_expand,
                    no_comment: !item.team.comment,
                  }"
                  :title="item.team.comment"
                >
                  <div
                    @click="openModal(item.team, 'team', item.team)"
                    v-if="!item.team.modal"
                    class="heatmap-comment-content"
                  >
                    {{ item.team.comment | validate }}
                  </div>
                  <input
                    v-else
                    type="text"
                    class="comment-content-editable"
                    v-model="form_comment.text"
                    @blur="updateHeatMapComment()"
                    @keypress.enter="updateHeatMapComment()"
                  />
                </div>
              </div>
              <div class="table-td-item-body" v-if="item.team.item_expanded">
                <div
                  class="table-td-body-item"
                  v-for="(member, i) in item.consultants"
                  :key="i"
                >
                  <div class="consultant">
                    <div class="user-info">
                      <img
                        v-if="member.profile.image"
                        :src="
                          $fullUrl('images/profiles/' + member.profile.image)
                        "
                        class="profile"
                      />
                      <img v-else src="@/assets/avatar.png" class="profile" />
                      <label
                        >{{ member.profile.first_name | validate }}
                        {{ member.profile.last_name | validate }}</label
                      >
                    </div>
                  </div>

                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(item.team, 'member', member, member.cell_1)
                      "
                      :style="{ 'background-color': member.cell_1.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(item.team, 'member', member, member.cell_2)
                      "
                      :style="{ 'background-color': member.cell_2.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(item.team, 'member', member, member.cell_3)
                      "
                      :style="{ 'background-color': member.cell_3.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(item.team, 'member', member, member.cell_4)
                      "
                      :style="{ 'background-color': member.cell_4.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(item.team, 'member', member, member.cell_5)
                      "
                      :style="{ 'background-color': member.cell_5.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(item.team, 'member', member, member.cell_6)
                      "
                      :style="{ 'background-color': member.cell_6.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(item.team, 'member', member, member.cell_7)
                      "
                      :style="{ 'background-color': member.cell_7.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(item.team, 'member', member, member.cell_8)
                      "
                      :style="{ 'background-color': member.cell_8.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(item.team, 'member', member, member.cell_9)
                      "
                      :style="{ 'background-color': member.cell_9.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.team,
                          'member',
                          member,
                          member.cell_10
                        )
                      "
                      :style="{ 'background-color': member.cell_10.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.team,
                          'member',
                          member,
                          member.cell_11
                        )
                      "
                      :style="{ 'background-color': member.cell_11.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.team,
                          'member',
                          member,
                          member.cell_12
                        )
                      "
                      :style="{ 'background-color': member.cell_12.color }"
                    ></div>
                  </div>

                  <div
                    class="heatmap-comment"
                    :class="{
                      expanded: comment_expand,
                      no_comment: !member.comment,
                    }"
                    :title="member.comment"
                  >
                    <div
                      @click="openModal(item.team, 'member', member)"
                      v-if="!member.modal"
                      class="heatmap-comment-content"
                    >
                      {{ member.comment | validate }}
                    </div>
                    <input
                      v-else
                      type="text"
                      class="comment-content-editable"
                      @blur="updateHeatMapComment()"
                      v-model="form_comment.text"
                      @keypress.enter="updateHeatMapComment()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-heatmap" v-else-if="heatmap_view_type == 'member'">
          <img class="icon" src="@/assets/admin-icon/no_heatmap.svg" />
          <h1>Your dashboard is empty</h1>
          <p>You need to add consultants to start using the heatmap</p>
          <img class="heatmap-image" src="@/assets/image/crm-heatmap.svg" />
          <button
            @click="
              $router.push({ name: 'organization', params: { type: 'teams' } })
            "
            class="btn-add"
          >
            Add Consultant
          </button>
        </div>

        <!-- Heatmap for department and team -->

        <div
          class="table-content"
          v-if="
            show_hit_map &&
            heatmap_data.data.length > 0 &&
            heatmap_view_type == 'team'
          "
          @click="mouse_position"
        >
          <div class="table-container" ref="table-content">
            <div class="table-row">
              <div class="consultant-item">
                <button class="btn-time-prev" @click="heatmapPrev()">
                  <img src="@/assets/admin-icon/chevron-left.svg" />
                </button>
              </div>
              <div
                v-for="(item, index) in heatmap_data.labels"
                :key="index"
                class="table-th-item"
                :class="{
                  has_year: (item.month == 'Jan' && index != 0) || index == 0,
                }"
              >
                <div class="year-label" v-if="index == 0">
                  {{ item.year | validate }}
                </div>
                <div
                  class="year-label"
                  v-if="item.month == 'Jan' && index != 0"
                >
                  {{ item.year | validate }}
                </div>
                <span
                  :class="{
                    year_number:
                      (item.month == 'Jan' && index != 0) || index == 0,
                  }"
                  >{{ item.month | validate }}</span
                >
              </div>

              <div class="comments-th" :class="{ expanded: comment_expand }">
                <button class="btn-next-time" @click="heatmapNext()">
                  <img src="@/assets/admin-icon/chevron-right.svg" />
                </button>
                <h3 @click="comment_expand = !comment_expand">Comments</h3>
                <button
                  class="btn-resize"
                  @click="comment_expand = !comment_expand"
                >
                  <span v-if="comment_expand">Minimize</span>
                  <span v-else>Expand</span>
                </button>
              </div>
            </div>
            <div
              class="table-td-row"
              v-for="(item, index) in heatmap_data.data"
              :key="index"
            >
              <div class="table-td-item-header">
                <div class="consultant">
                  <button
                    class="btn-toggle-team"
                    @click="expandHeatmapItem(item.department)"
                  >
                    <img
                      v-if="!item.department.item_expanded"
                      src="@/assets/admin-icon/gray-caret-down.svg"
                    />
                    <img v-else src="@/assets/admin-icon/gray-caret-up.svg" />
                  </button>
                  <div class="user-info">
                    <label
                      >{{ item.department.profile.name | validate }}
                    </label>
                  </div>
                </div>

                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_1
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_1.color,
                    }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_2
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_2.color,
                    }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_3
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_3.color,
                    }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_4
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_4.color,
                    }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_5
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_5.color,
                    }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_6
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_6.color,
                    }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_7
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_7.color,
                    }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_8
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_8.color,
                    }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_9
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_9.color,
                    }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_10
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_10.color,
                    }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_11
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_11.color,
                    }"
                  ></div>
                </div>
                <div class="table-td-item">
                  <div
                    class="color-box"
                    @click="
                      showBoxModal(
                        item.department,
                        'department',
                        item.department,
                        item.department.cell_12
                      )
                    "
                    :style="{
                      'background-color': item.department.cell_12.color,
                    }"
                  ></div>
                </div>

                <div
                  class="heatmap-comment"
                  :class="{
                    expanded: comment_expand,
                    no_comment: !item.department.comment,
                  }"
                  :title="item.department.comment"
                >
                  <div
                    @click="
                      openModal(item.department, 'department', item.department)
                    "
                    v-if="!item.department.modal"
                    class="heatmap-comment-content"
                  >
                    {{ item.department.comment | validate }}
                  </div>
                  <input
                    v-else
                    type="text"
                    class="comment-content-editable"
                    v-model="form_comment.text"
                    @blur="updateHeatMapComment()"
                    @keypress.enter="updateHeatMapComment()"
                  />
                </div>
              </div>
              <div
                class="table-td-item-body"
                v-if="item.department.item_expanded"
              >
                <div
                  class="table-td-body-item"
                  v-for="(member, i) in item.teams"
                  :key="i"
                >
                  <div class="consultant">
                    <div class="user-info">
                      <img
                        v-if="member.profile.image"
                        :src="
                          $fullUrl('images/profiles/' + member.profile.image)
                        "
                        class="profile"
                      />
                      <img v-else src="@/assets/avatar.png" class="profile" />
                      <label>{{ member.profile.name | validate }}</label>
                    </div>
                  </div>

                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_1
                        )
                      "
                      :style="{ 'background-color': member.cell_1.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_2
                        )
                      "
                      :style="{ 'background-color': member.cell_2.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_3
                        )
                      "
                      :style="{ 'background-color': member.cell_3.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_4
                        )
                      "
                      :style="{ 'background-color': member.cell_4.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_5
                        )
                      "
                      :style="{ 'background-color': member.cell_5.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_6
                        )
                      "
                      :style="{ 'background-color': member.cell_6.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_7
                        )
                      "
                      :style="{ 'background-color': member.cell_7.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_8
                        )
                      "
                      :style="{ 'background-color': member.cell_8.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_9
                        )
                      "
                      :style="{ 'background-color': member.cell_9.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_10
                        )
                      "
                      :style="{ 'background-color': member.cell_10.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_11
                        )
                      "
                      :style="{ 'background-color': member.cell_11.color }"
                    ></div>
                  </div>
                  <div class="table-td-item">
                    <div
                      class="color-box"
                      @click="
                        showBoxModal(
                          item.department,
                          'team',
                          member,
                          member.cell_12
                        )
                      "
                      :style="{ 'background-color': member.cell_12.color }"
                    ></div>
                  </div>

                  <div
                    class="heatmap-comment"
                    :class="{
                      expanded: comment_expand,
                      no_comment: !member.comment,
                    }"
                    :title="member.comment"
                  >
                    <div
                      @click="openModal(item.department, 'team', member)"
                      v-if="!member.modal"
                      class="heatmap-comment-content"
                    >
                      {{ member.comment | validate }}
                    </div>
                    <input
                      v-else
                      type="text"
                      class="comment-content-editable"
                      @blur="updateHeatMapComment()"
                      v-model="form_comment.text"
                      @keypress.enter="updateHeatMapComment()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-heatmap" v-else-if="heatmap_view_type == 'team'">
          <img class="icon" src="@/assets/admin-icon/no_heatmap.svg" />
          <h1>Your dashboard is empty</h1>
          <p>You need to add team to start using the heatmap</p>
          <img class="heatmap-image" src="@/assets/image/crm-heatmap.svg" />
          <button
            @click="
              $router.push({ name: 'organization', params: { type: 'teams' } })
            "
            class="btn-add"
          >
            Add Team
          </button>
        </div>
      </div>
    </div>

    <!-- Box overlay -->
    <div
      class="boxs-modal"
      :style="box_modal_style"
      v-if="show_box_modal"
      v-closable="{
        exclude: ['table-content'],
        handler: 'hideTableContent',
      }"
    >
      <div
        class="box-item"
        @click="updateHeatMap('Assignments 100%', '#1BA5A4')"
      >
        <div class="box" style="background: #1ba5a4"></div>
        <span>Assignments 100%</span>
      </div>

      <div
        class="box-item"
        @click="updateHeatMap('Assignments part time', '#A9CB6F')"
      >
        <div class="box" style="background: #a9cb6f"></div>
        <span>Assignments part time</span>
      </div>

      <div class="box-item" @click="updateHeatMap('Lead', '#EACE3B')">
        <div class="box" style="background: #eace3b"></div>
        <span>Lead</span>
      </div>

      <div
        class="box-item"
        @click="updateHeatMap('Assignments part time', '#D30000')"
      >
        <div class="box" style="background: #d30000"></div>
        <span>No assignments and no leads</span>
      </div>

      <div
        class="box-item"
        @click="updateHeatMap('Zero opportunity', '#7E7E7E')"
      >
        <div class="box" style="background: #7e7e7e"></div>
        <span>Zero opportunity</span>
      </div>
      <div class="box-item" @click="updateHeatMap('Not Available', '#C4C4C4')">
        <div class="box" style="background: #c4c4c4"></div>
        <span>Not Available</span>
      </div>
    </div>
    <!-- Startup wizard -->
    <StartUpWizard
      v-if="show_wizard"
      @checkWizard="manageWizard"
    ></StartUpWizard>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import StartUpWizard from "@/components/StartUpWizard.vue";
export default {
  name: "dashboard",
  components: {
    StartUpWizard,
  },
  data() {
    return {
      box_modal_style: {},
      show_wizard: true,
      show_box_modal: false,
      view_type: null,
      comment_expand: true,
      form_comment: {
        id: null,
        text: "",
        type: "",
        crm_department_id: null,
        crm_team_id: null,
      },
      heatmap_data: {
        data: [],
        labels: [],
      },
      show_hit_map: false,
      form: {
        id: null,
        crm_team_id: null,
        crm_department_id: null,
        type: "",
        color: "",
        month: "",
        year: "",
        status: "",
      },
      selected_item: {},
      selected_cell: {},
      team_ids: [],
      department_ids: [],
      heatmap_view_type: "",
    };
  },
  watch: {},
  mounted() {
    let vm = this;
    let path = [
      {
        label: "Dashboard",
        active:true
      },
    ];
    vm.$store.commit("SET_PATH", path);
    vm.getTeamsData();
  },
  methods: {
    TeamSelected(team_id) {
      let vm = this;
      vm.team_ids = team_id;
      vm.heatmap_view_type = "member";
      vm.show_hit_map = false;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("HEATMAP_GET_ALL_DATA", {
          teams: vm.team_ids,
          prefix: "team-manager",
        })
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.heatmap_data = response.data;
          vm.heatmap_data.data = vm.heatmap_data.data.map((item) => {
            if (vm.heatmap_data.data.length == 1) {
              eventBus.$set(item.team, "item_expanded", true);
            } else {
              eventBus.$set(item.team, "item_expanded", false);
            }
            eventBus.$set(item.team, "modal", false);
            item.consultants = item.consultants.map((member) => {
              eventBus.$set(member, "modal", false);
              eventBus.$set(member, "item_expanded", false);
              return member;
            });
            return item;
          });
          vm.show_hit_map = true;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    DeapartmentSelected(department_id) {
      let vm = this;
      vm.department_ids = department_id;
      vm.heatmap_view_type = "team";
      vm.show_hit_map = false;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("HEATMAP_GET_ALL_DATA", {
          departments: vm.department_ids,
          prefix: "super-manager",
        })
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.heatmap_data = response.data;
          vm.heatmap_data.data = vm.heatmap_data.data.map((item) => {
            if (vm.heatmap_data.data.length == 1) {
              eventBus.$set(item.department, "item_expanded", true);
            } else {
              eventBus.$set(item.department, "item_expanded", false);
            }
            eventBus.$set(item.department, "modal", false);
            item.teams = item.teams.map((team) => {
              eventBus.$set(team, "modal", false);
              eventBus.$set(team, "item_expanded", false);
              return team;
            });
            return item;
          });
          vm.show_hit_map = true;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    getHeatMapData() {
      let vm = this;
      vm.show_hit_map = false;
      vm.heatmap_view_type = "team";
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("HEATMAP_GET_ALL_DATA", {
          departments: vm.department_ids,
          prefix: "super-manager",
        })
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.heatmap_data = response.data;
          vm.heatmap_data.data = vm.heatmap_data.data.map((item) => {
            if (vm.heatmap_data.data.length == 1) {
              eventBus.$set(item.department, "item_expanded", true);
            } else {
              eventBus.$set(item.department, "item_expanded", false);
            }
            eventBus.$set(item.department, "modal", false);
            item.teams = item.teams.map((team) => {
              eventBus.$set(team, "modal", false);
              eventBus.$set(team, "item_expanded", false);
              return team;
            });
            return item;
          });
          vm.show_hit_map = true;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    getTeamsData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("GET_ALL_USER_INFO")
        .then((response) => {
          if (vm.$localStorage.get("role") == "team-manager") {
            vm.team_ids = response.data.map((item) => item.id);
            vm.TeamSelected(vm.team_ids);
          } else {
            vm.department_ids = response.data.map((item) => item.id);
            vm.getHeatMapData();
          }
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    heatmapPrev() {
      let vm = this;
      let payload = vm.heatmap_data.labels[10];
      let prefix = "";
      if (vm.heatmap_view_type == "team") {
        eventBus.$set(payload, "departments", vm.department_ids);
        prefix = "/super-manager";
      }
      if (vm.heatmap_view_type == "member") {
        eventBus.$set(payload, "teams", vm.team_ids);
        prefix = "/team-manager";
      }
      eventBus.$set(payload, "prefix", prefix);
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("HEATMAP_GET_PREV_DATA", payload)
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.heatmap_data = response.data;
          vm.heatmap_data.data = vm.heatmap_data.data.map((item) => {
            if (vm.heatmap_data.data.length == 1) {
              eventBus.$set(item.team, "item_expanded", true);
            } else {
              eventBus.$set(item.team, "item_expanded", false);
            }
            eventBus.$set(item.team, "modal", false);
            item.consultants = item.consultants.map((member) => {
              eventBus.$set(member, "modal", false);
              eventBus.$set(member, "item_expanded", false);
              return member;
            });
            return item;
          });
          vm.show_hit_map = true;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    heatmapNext() {
      let vm = this;
      let last_index = vm.heatmap_data.labels.length - 10;
      let payload = vm.heatmap_data.labels[last_index];
      let prefix = "";
      if (vm.heatmap_view_type == "team") {
        eventBus.$set(payload, "departments", vm.department_ids);
        prefix = "/super-manager";
      }
      if (vm.heatmap_view_type == "member") {
        eventBus.$set(payload, "teams", vm.team_ids);
        prefix = "/team-manager";
      }
      eventBus.$set(payload, "prefix", prefix);
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("HEATMAP_GET_NEXT_DATA", payload)
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.heatmap_data = response.data;
          vm.heatmap_data.data = vm.heatmap_data.data.map((item) => {
            if (vm.heatmap_data.data.length == 1) {
              eventBus.$set(item.team, "item_expanded", true);
            } else {
              eventBus.$set(item.team, "item_expanded", false);
            }
            eventBus.$set(item.team, "modal", false);
            item.consultants = item.consultants.map((member) => {
              eventBus.$set(member, "modal", false);
              eventBus.$set(member, "item_expanded", false);
              return member;
            });
            return item;
          });
          vm.show_hit_map = true;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    expandHeatmapItem(item) {
      item.item_expanded = !item.item_expanded;
    },
    manageWizard(status) {
      let vm = this;
      vm.show_wizard = status;
    },
    updateHeatMapComment() {
      let vm = this;
      vm.selected_item.comment = vm.form_comment.text;
      vm.hideAllDeatilsModal();
      if (vm.form_comment.type == "member") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_USER_COMMENT", vm.form_comment)
          .then((response) => {})
          .catch((error) => {
            console.error({ error });
          });
      } else if (vm.form_comment.type == "team") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_TEAM_COMMENT", vm.form_comment)
          .then((response) => {})
          .catch((error) => {
            console.error({ error });
          });
      } else if (vm.form_comment.type == "department") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_DEPARTMENT_COMMENT", vm.form_comment)
          .then((response) => {})
          .catch((error) => {
            console.error({ error });
          });
      }
    },
    updateHeatMap(status, color) {
      let vm = this;
      vm.form.color = color;
      vm.form.status = status;
      if (vm.form.type == "member") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_USER", vm.form)
          .then((response) => {
            vm.selected_cell.color = color;
            vm.hideAllDeatilsModal();
            vm.hideTableContent();
          })
          .catch((error) => {
            console.error({ error });
          });
      } else if (vm.form.type == "team") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_TEAM", vm.form)
          .then((response) => {
            vm.selected_cell.color = color;
            vm.hideAllDeatilsModal();
            vm.hideTableContent();
          })
          .catch((error) => {
            console.error({ error });
          });
      } else if (vm.form.type == "department") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_DEPARTMENT", vm.form)
          .then((response) => {
            vm.selected_cell.color = color;
            vm.hideAllDeatilsModal();
            vm.hideTableContent();
          })
          .catch((error) => {
            console.error({ error });
          });
      }
    },
    hideAllDeatilsModal() {
      let vm = this;
      if (vm.heatmap_view_type == "member") {
        vm.heatmap_data.data.forEach((val) => {
          val.team.modal = false;
          val.consultants.forEach((item) => {
            item.modal = false;
          });
        });
      } else if (vm.heatmap_view_type == "team") {
        vm.heatmap_data.data.forEach((val) => {
          val.department.modal = false;
          val.teams.forEach((item) => {
            item.modal = false;
          });
        });
      }
    },
    openModal(data_item, type, item) {
      let vm = this;
      vm.form_comment = {
        id: null,
        text: "",
        type: "",
        crm_department_id: null,
        crm_team_id: null,
      };
      vm.hideAllDeatilsModal();
      vm.form_comment.id = item.id;
      vm.form_comment.type = type;
      console.log(type);
      if (vm.form_comment.type == "team") {
        vm.form_comment.crm_team_id = data_item.profile.id;
      } else if (vm.form_comment.type == "department") {
        vm.form_comment.crm_department_id = data_item.profile.id;
      }
      vm.form_comment.text = item.comment;
      vm.selected_item = item;
      item.modal = true;
      setTimeout(() => {
        document.querySelector(".comment-content-editable").focus();
      }, 200);
    },
    hideTableContent() {
      let vm = this;
      vm.show_box_modal = false;
    },
    mouse_position(e) {
      let vm = this;
      if (e.clientY < 380) {
        vm.box_modal_style = {
          top: e.clientY + "px",
          left: e.clientX + "px",
        };
      } else {
        vm.box_modal_style = {
          top: e.clientY - 240 + "px",
          left: e.clientX + "px",
        };
      }
    },
    getRandowColor() {
      var colors = [
        "#6BB069",
        "#A9CB6F",
        "#DFDF74",
        "#EA9C65",
        "#C4C4C4",
        "#DD5959",
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    showBoxModal(data_item, type, item, cell) {
      let vm = this;
      vm.selected_cell = cell;
      vm.form = {
        id: item.id,
        type: type,
        crm_team_id: type == "team" ? data_item.profile.id : null,
        crm_department_id: type == "department" ? data_item.profile.id : null,
        color: "",
        month: cell.month,
        year: cell.year,
      };
      vm.show_box_modal = true;
    },
    yearScoll() {
      let el = document.querySelectorAll(".year_number")[0];
      let rect = el.getBoundingClientRect();
      if (rect.left < 20) {
        el.style.opacity = 0;
      } else {
        el.style.opacity = 1;
      }
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  .page-header {
    background: #dfdfdf;
    .page-ribbon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 41px;
      padding: 0px 15px;
      background: #fff;
      .path {
        color: #0884af;
        font-size: 13px;
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 6px;
        }
        span {
          margin-top: 4px;
        }
      }
      .ribbon-options {
        display: flex;
        align-items: center;
        .btn-search {
          border: none;
          background: transparent;
          img {
            width: 13px;
            object-fit: contain;
          }
        }
        .btn-customer-user {
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          .profile-logo {
            width: 15px;
            height: 15px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 5px;
          }
          span {
            margin-right: 5px;
          }
        }
      }
    }
    .page-options {
      display: flex;
      padding: 6px 15px;
      background: #d0d0d0;
      min-height: 50px;
      .btn-option {
        background: transparent;
        color: #000;
        border: none;
        padding: 10px 30px;
        border-radius: 5px;
        cursor: pointer;
        outline: none;
        &.active {
          background: #fff;
          color: #0884af;
        }
      }
    }
  }
  .page-body {
    height: calc(100% - 40px);
    background: #fff;
    padding: 10px 10px;
    display: flex;
    flex-direction: column;
    .main-content {
      display: flex;
      height: calc(100% - 0px);
      width: 100%;
      position: relative;
      overflow-y: auto;
      padding-top: 30px;
      .table-content {
        width: 100%;
        height: 100%;
        position: relative;
        .table-container {
          width: 100%;
          .table-row {
            padding: 0px;
            display: flex;
            width: 100%;
            .consultant-item {
              width: 20%;
              border-bottom: 1px solid #ddd;
              position: relative;
              display: flex;
              align-items: center;
              .btn-time-prev {
                position: absolute;
                right: -20px;
                z-index: 99;
                top: 12px;
                img {
                  width: 11px;
                }
              }
            }
            .table-th-item {
              border-bottom: 1px solid #ddd;
              background: #fff;
              width: 7%;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;

              &.divider {
                border-right: 1px solid #ddd;
              }
              &.has_year {
                border-left: 1px solid #ddd;
                @media (min-width: 300px) and (max-width: 630px) {
                  position: sticky;
                  z-index: 99999999999999;
                  top: -30px;
                  left: -11px;
                  background: transparent;
                }
              }
              .year-label {
                position: absolute;
                top: -28px;
                left: -1px;
                border-left: 1px solid #cccc;
                padding: 7px 16px;
              }
            }
            .comments-th {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 250px;
              border-left: 1px solid #cccc;
              padding-left: 7px;
              border-bottom: 1px solid #ddd;
              position: relative;
              transition: 800ms ease-in-out;
              &.expanded {
                width: 600px;
                transition: 800ms ease-in-out;
              }
              .btn-next-time {
                position: absolute;
                left: -20px;
                top: 13px;
                img {
                  width: 11px;
                }
              }
              h3 {
                font-weight: 800;
                margin: 0px;
                cursor: pointer;
              }
              .btn-resize {
                color: #0884af;
              }
            }
          }
          .table-td-row {
            padding: 0px;
            display: flex;
            width: 100%;
            flex-direction: column;
            .table-td-item-header {
              width: 100%;
              padding: 0px;
              display: flex;
              .consultant {
                width: 20%;
                border-bottom: 1px solid #ddd;
                position: relative;
                .btn-toggle-team {
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  bottom: 0px;
                  z-index: 9;
                  img {
                    width: 13px;
                  }
                }
                .user-info {
                  display: flex;
                  align-items: center;
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  right: 0px;
                  bottom: 0px;
                  .profile {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    object-fit: cover;
                    margin-right: 4px;
                  }
                  label {
                    width: 100%;
                    overflow: hidden;
                    text-decoration: none;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
              .table-td-item {
                border-bottom: 1px solid #ddd;
                background: #fff;
                width: 7%;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                cursor: pointer;
                &:hover {
                  border: 1px solid #000;
                }
                .color-box {
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  right: 0px;
                  bottom: 0px;
                }
              }
              .heatmap-comment {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 250px;
                border-left: 1px solid #cccc;
                padding-left: 7px;
                border-bottom: 1px solid #ddd;
                position: relative;
                transition: 800ms ease-in-out;
                cursor: pointer;
                .heatmap-comment-content {
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  right: 0px;
                  bottom: 0px;
                  align-items: center;
                  padding-left: 7px;
                  padding-top: 7px;
                }
                .comment-content-editable {
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  right: 0px;
                  bottom: 0px;
                  width: 100%;
                  height: 100%;
                  padding-left: 7px;
                }
                &.expanded {
                  width: 600px;
                  transition: 800ms ease-in-out;
                }
              }
            }
            .table-td-item-body {
              width: 100%;
              padding: 0px;
              display: flex;
              flex-direction: column;
              .table-td-body-item {
                width: 100%;
                padding: 0px;
                display: flex;
                .consultant {
                  width: 20%;
                  border-bottom: 1px solid #ddd;
                  position: relative;

                  .user-info {
                    display: flex;
                    align-items: center;
                    padding-left: 20px;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    bottom: 0px;
                    .profile {
                      width: 20px;
                      height: 20px;
                      border-radius: 50%;
                      object-fit: cover;
                      margin-right: 4px;
                    }
                    label {
                      width: 100%;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                  }
                }
                .table-td-item {
                  border-bottom: 1px solid #ddd;
                  background: #fff;
                  width: 7%;
                  height: 30px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                  cursor: pointer;
                  &:hover {
                    border: 1px solid #000;
                  }
                  .color-box {
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    bottom: 0px;
                  }
                }
                .heatmap-comment {
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  width: 250px;
                  border-left: 1px solid #cccc;
                  padding-left: 7px;
                  border-bottom: 1px solid #ddd;
                  position: relative;
                  transition: 800ms ease-in-out;
                  cursor: pointer;
                  .heatmap-comment-content {
                    overflow: hidden;
                    text-decoration: none;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    bottom: 0px;
                    align-items: center;
                    padding-left: 7px;
                    padding-top: 7px;
                  }
                  .comment-content-editable {
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    bottom: 0px;
                    width: 100%;
                    height: 100%;
                    padding-left: 7px;
                  }
                  &.expanded {
                    width: 600px;
                    transition: 800ms ease-in-out;
                  }
                }
              }
            }
          }
        }
      }
      .empty-heatmap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        img.icon {
          width: 100px;
          margin-top: -90px;
          margin-bottom: 20px;
        }
        h1 {
          font-family: Avenir;
          font-style: normal;
          font-weight: 800;
          font-size: 21px;
          text-align: center;
          color: #cccccc;
          margin: 10px 0px;
        }
        p {
          font-family: Avenir;
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          text-align: center;
          color: #676767;
          margin: 0px 0px;
          margin-bottom: 25px;
        }
        .heatmap-image {
          width: 653px;
          margin-bottom: 20px;
        }
        .btn-add {
          width: 315px;
          height: 50px;
          color: #fff;
          background: #0884af;
          border-radius: 5px;
          font-weight: 800;
        }
      }
      .details-content {
        width: 300px;
        padding-left: 10px;
        .content {
          padding: 15px 0px;
          .details-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            h3 {
              font-size: 18px;
              margin: 0px;
            }
          }
          .boxs-wiget {
            display: flex;
            flex-direction: column;
            .box-item {
              display: flex;
              align-items: center;
              border: 1px solid #ccc;
              background: rgb(240, 240, 240);
              padding: 10px 10px;
              position: relative;
              cursor: pointer;
              .box-modal {
                position: absolute;
                top: 20px;
                right: 0px;
                background: #fff;
                z-index: 9999;
                width: 300px;
                border: 1px solid #1ba5a4;
                border-radius: 5px;
                padding: 10px;
              }
              span {
                font-size: 12px;
                color: #676767;
              }
            }
          }
        }
      }
    }
    .pagination-widget {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 20px;
      .pages {
        display: flex;
        .page {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 30px;
          width: 30px;
          margin-right: 20px;
          border: 1px solid #ddd;
          font-weight: 800;
          border-radius: 4px;
          cursor: pointer;
          &.active {
            border: 1px solid #1ba5a4;
            color: #1ba5a4;
          }
        }
        .btn-prev {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 30px;
          width: 30px;
          margin-right: 20px;
          border: 1px solid #ddd;
          font-weight: 800;
          border-radius: 4px;
          &.disabled {
            cursor: not-allowed;
            opacity: 0.3;
          }
        }
        .btn-next {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 30px;
          width: 30px;
          border: 1px solid #ddd;
          font-weight: 800;
          border-radius: 4px;
          &.disabled {
            cursor: not-allowed;
            opacity: 0.3;
          }
        }
      }
    }
  }
  .boxs-modal {
    position: fixed;
    background: #fff;
    z-index: 9999999;
    border-radius: 5px;
    display: grid;
    grid-row-gap: 0px;
    box-shadow: 0px 0px 5px #000;
    @media (min-width: 300px) and (max-width: 630px) {
      left: 0% !important;
    }
    .box-item {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 10px 10px;
      &:hover {
        background: #ddd;
        border-radius: 5px;
      }
      .box {
        width: 40px;
        height: 20px;
        margin-right: 8px;
      }
      span {
        cursor: pointer;
        font-size: 12px;
      }
    }
  }
}
</style>
